module.exports = __webpack_public_path__ + "static/media/contato_new.70bc4919.png";